import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove injected Emergent badge
const removeBadge = () => {
  // Target all divs that are direct children of body except #root
  document.querySelectorAll('body > div:not(#root)').forEach(el => {
    const style = window.getComputedStyle(el);
    if (style.position === 'fixed' || style.position === 'absolute') {
      el.style.cssText = 'display: none !important; visibility: hidden !important; opacity: 0 !important; width: 0 !important; height: 0 !important; pointer-events: none !important;';
    }
  });
  
  // Target iframes
  document.querySelectorAll('iframe').forEach(el => {
    if (!el.closest('#root')) {
      el.style.cssText = 'display: none !important;';
    }
  });
};

// Run on load and with delays
window.addEventListener('load', () => {
  removeBadge();
  setTimeout(removeBadge, 500);
  setTimeout(removeBadge, 1000);
  setTimeout(removeBadge, 2000);
  setTimeout(removeBadge, 5000);
});

// Mutation observer to catch dynamically added badges
const observer = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    if (mutation.addedNodes.length > 0) {
      removeBadge();
      break;
    }
  }
});

// Start observing after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.body, { childList: true });
  });
} else {
  observer.observe(document.body, { childList: true });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
